import { __awaiter } from "tslib";
import waitUntil from '../../common/waitUntil';
import consoleEvents from '../../consoleEvents';
const getIsContentSquareConfigAvailable = () => {
    return window.CS_CONF && window._uxa;
};
const optimizelyVanillaOnDecision = (decision) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    if (decision.type === 'flag' &&
        ((_a = window.abTest) === null || _a === void 0 ? void 0 : _a.trackExperiment) &&
        ((_b = decision.decisionInfo) === null || _b === void 0 ? void 0 : _b.decisionEventDispatched) &&
        ((_c = decision.decisionInfo) === null || _c === void 0 ? void 0 : _c.flagKey) &&
        ((_d = decision.decisionInfo) === null || _d === void 0 ? void 0 : _d.variationKey)) {
        // Send to GA
        window.abTest.trackExperiment(`${decision.decisionInfo.flagKey}|${decision.decisionInfo.ruleKey}`, decision.decisionInfo.variationKey);
        consoleEvents.info(`DECISION FOR FLAG: ${decision.decisionInfo.flagKey} SENT TO GA/CS FOR VISITOR: ${decision.userId}. RULE: ${decision.decisionInfo.ruleKey}. VARIATION: ${decision.decisionInfo.variationKey}. `);
        // Send to CS
        let disableCallback = false;
        const callback = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!disableCallback) {
                disableCallback = true;
                try {
                    window.CS_CONF.integrations = window.CS_CONF.integrations || [];
                    window.CS_CONF.integrations.push('Optimizely Full Stack');
                }
                catch (_f) {
                    consoleEvents.info('window.CS_CONF is not available');
                }
            }
        });
        try {
            yield waitUntil(getIsContentSquareConfigAvailable);
            window._uxa.push(['afterPageView', callback]);
            const csPrefix = 'AB_OP_';
            const csKey = `${csPrefix + decision.decisionInfo.flagKey}|${decision.decisionInfo.ruleKey}`;
            const csValue = decision.decisionInfo.variationKey;
            window._uxa = window._uxa || [];
            window._uxa.push(['trackDynamicVariable', { key: csKey, value: csValue }]);
        }
        catch (_e) {
            consoleEvents.info('window._uxa is not available');
        }
    }
});
export default optimizelyVanillaOnDecision;
//# sourceMappingURL=optimizelyVanillaOnDecision.js.map